import React, { useEffect } from "react";
import { connect } from "react-redux";

import Login from "../index";
import { loginSSO } from "../../../store/ducks/auth";
import { getRedirectIntegrationUrl } from "../../../store/ducks/auth";

const LoginSSO = ({ history, location, loginSSO }) => {
  const query = new URLSearchParams(location.search);

  useEffect(() => {
    const sso = query.get("sso");
    const code = query.get("code");

    if (!sso) {
      history.push("/");
      return;
    }

    if (sso && code) {
      loginSSO(sso, code);
    } else if (sso) {
      window.location.href = getRedirectIntegrationUrl(sso);
    }
  }, [query, history, loginSSO]);

  return <Login sso={true} />;
};

const mapDispatchToProps = { loginSSO };

export default connect(null, mapDispatchToProps)(LoginSSO);
